import { useTranslation } from 'react-i18next';
import { Pencil, Icon } from '../../../ui/Icon';
import { CurrencySelect } from '../../../ui/CurrencySelect';
import type { Step } from '../types';

export interface RecapRow {
  step: Step;
  label: string;
  value: string;
}

interface Props {
  rows: RecapRow[];
  onEdit: (step: Step) => void;
  name: string;
  onName: (name: string) => void;
  currency: string;
  onCurrency: (currency: string) => void;
}

export default function SummaryStep({ rows, onEdit, name, onName, currency, onCurrency }: Props) {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <div>
        <label className="label" htmlFor="wizard-name">{t('dashboard.newTripWizard.nameLabel')}</label>
        <input
          id="wizard-name" type="text" className="input !h-12 !text-[16px] !rounded-2xl font-medium" maxLength={100}
          value={name} onChange={e => onName(e.target.value)}
        />
      </div>

      <dl className="rounded-2xl bg-white dark:bg-slate-900/60 border border-slate-200 dark:border-slate-800 divide-y divide-slate-100 dark:divide-slate-800">
        {rows.map(row => (
          <div key={row.step} className="flex items-center gap-3 px-4 py-3">
            <dt className="w-28 shrink-0 text-[12px] font-semibold uppercase tracking-wide text-slate-400">{row.label}</dt>
            <dd className="flex-1 min-w-0 text-[14px] text-slate-800 dark:text-slate-200">{row.value}</dd>
            <button
              type="button" onClick={() => onEdit(row.step)}
              className="btn-icon w-8 h-8 text-slate-400 hover:text-teal-600"
              aria-label={t('dashboard.newTripWizard.editAnswer')}
            >
              <Icon as={Pencil} size={14} />
            </button>
          </div>
        ))}
      </dl>

      <div>
        <label className="label">{t('dashboard.newTripWizard.currencyLabel')}</label>
        <CurrencySelect value={currency} onChange={onCurrency} />
        <p className="text-[12px] text-slate-400 mt-1">{t('dashboard.newTripWizard.currencyHint')}</p>
      </div>
    </div>
  );
}
